import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=38276cdc&scoped=true"
import script from "./drawer.vue?vue&type=script&lang=js"
export * from "./drawer.vue?vue&type=script&lang=js"
import style0 from "./drawer.vue?vue&type=style&index=0&id=38276cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38276cdc",
  null
  
)

export default component.exports